module.exports = __webpack_public_path__ + "df810bb38b52d769f92f7460b2e716d4.pdf";